import { sanitizeString } from '../utils';
import { ClientRequestType, ServerRequestType } from './types';

export const transformViolationChallengeRequest = (
  data: ClientRequestType
): ServerRequestType => {
  return {
    challengeReason: sanitizeString(data.challengeReason),
    reasonText: sanitizeString(data.reasonText),
  };
};
